import {AxiosInstance} from "axios";
import DateUtils from "../utils/DateUtils";
import GeneralLedger from "../model/generalLedger/GeneralLedger";
import moment = require("moment");

/**
 * General ledger Api.
 */
export default class GeneralLedgerApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	fetchGeneralLedger(partnerBrandId: string, from: moment.Moment, to: moment.Moment): Promise<GeneralLedger> {
		const dateFrom = from.format(DateUtils.ISO_DATE_FORMAT);
		const dateTo = to.format(DateUtils.ISO_DATE_FORMAT);
		const url = `/api/web/accounting/partner_brands/${partnerBrandId}/general_ledger`;
		const query = {params: {dateFrom, dateTo}};
		return this.axiosInstance.get(url, query).then(resp => GeneralLedger.fromJson(resp.data));
	}
}
